import React from 'react';
import {SectionMain, Tabs, Tab} from 'components/core';
import ChannelsList from './list';
import ChannelPanel from './panel';
import Singletons from 'controllers/Singletons';
import {ChannelsCtxProvider, ChannelsCtx} from 'components/dataProviders/channels';
import CreateDialog from './create';

export default function ChannelWrapper()
{
  return <ChannelsCtxProvider><Channel></Channel></ChannelsCtxProvider>
}


function Channel()
{
    const [selectedTab, setSelectedTab] = React.useState(0);
    const [showOperation, setShowOperation] = React.useState(false);
    const [selectedOperation, setSelectedOperation] = React.useState(null);
    const [newDialogOpen, setNewDialogOpen] = React.useState(false);
    

    const opsCtx = React.useContext(ChannelsCtx);
    

    React.useEffect(function ClearNotifications(){
      opsCtx.funcs.clearNotifications(selectedOperation);
    }, [opsCtx, selectedOperation]);


    const handleRowSelected = (row) =>
    {
      setSelectedOperation(row.id);
      setShowOperation(true);
    }

    const handleNewButtonClick = () =>
    {
      setNewDialogOpen(true);
    }

    const handleTabChange = (index) =>
    {
      if(index !== selectedTab)
      {
        setShowOperation(false);
        setSelectedOperation(null);
        setSelectedTab(index);
      }
    }

    const handleClosePanel = () =>
    {
        setShowOperation(false);
        setSelectedOperation(null);
    }

    // const tabs = <Tabs value={selectedTab} onChange={(evt, index) => handleTabChange(index)} textColor="primary" indicatorColor="primary">
    //     <Tab label="Tickets Abiertos"/>
    //     <Tab label="Tickets Archivados"/>
    // </Tabs>
    const tabs = null;

    const panel = <ChannelPanel channelID={selectedOperation} onClose={() => handleClosePanel()}/>

    return <SectionMain title="Canales" buttonLabel="Nuevo Canal" tabs={tabs} showDetail={showOperation} onButtonClick={() => handleNewButtonClick()} detail = {panel} buttonDisabled={false}>
      <CreateDialog open={newDialogOpen} onClose={()=>setNewDialogOpen(false)} />
      <ChannelsList onRowSelected={(row) => handleRowSelected(row)} collapsed={showOperation}/>
    </SectionMain>
}
